/**
 * StaffNoteChangeSection - Section wrapper for staff note change cards.
 *
 * Sorts: created → updated → deleted → ignored.
 */

import { useMemo } from 'react';

import { Badge } from '@/components/ui/catalyst/badge';
import type { EntityChangeSchema } from '@/services/api/generated/entityChangesService';

import { CHANGE_TYPE_ORDER } from './changeTypeConfig';
import { StaffNoteChangeCard } from './StaffNoteChangeCard';

interface StaffNoteChangeSectionProps {
  staffNotes: EntityChangeSchema[];
}

export const StaffNoteChangeSection: React.FC<StaffNoteChangeSectionProps> = ({
  staffNotes,
}) => {
  const sorted = useMemo(
    () =>
      [...staffNotes].sort(
        (a, b) =>
          CHANGE_TYPE_ORDER[a.change_type] -
          CHANGE_TYPE_ORDER[b.change_type],
      ),
    [staffNotes],
  );

  if (staffNotes.length === 0) return null;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <h3 className="text-base font-semibold text-gray-900">Staff Notes</h3>
        <Badge color="zinc" className="text-xs">
          {staffNotes.length}
        </Badge>
      </div>
      <div className="space-y-2">
        {sorted.map((note) => (
          <StaffNoteChangeCard key={note.id} entity={note} />
        ))}
      </div>
    </div>
  );
};
